import { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button, Sheet, SheetContent } from "@/shared/components/ui";
import { Logo } from "@/shared/components/Logo";
import { Sidebar } from "./Sidebar";

export function MobileTopBar() {
  const [open, setOpen] = useState(false);
  const handleNavigate = useCallback(() => setOpen(false), []);

  return (
    <header className="h-14 bg-visagio-teal-dark flex items-center px-4 gap-3 shrink-0 shadow-lg z-30">
      <Sheet open={open} onOpenChange={setOpen}>
        <Button
          variant="ghost"
          size="icon"
          className="text-white/80 hover:text-white hover:bg-visagio-teal/50 shrink-0"
          onClick={() => setOpen(true)}
          aria-label="Abrir menu"
        >
          <Menu className="h-5 w-5" />
        </Button>

        <SheetContent
          side="left"
          className="p-0 w-[280px] bg-visagio-teal-dark border-r border-visagio-teal/30 [&>button]:text-white/70 [&>button]:hover:text-white [&>button]:focus:ring-white/30"
        >
          <Sidebar
            collapsed={false}
            onCollapsedChange={() => {}}
            mobileMode={true}
            onNavigate={handleNavigate}
          />
        </SheetContent>
      </Sheet>

      <Link to="/dashboard" className="flex-1 flex justify-center">
        <Logo size="sm" showText={true} />
      </Link>
    </header>
  );
}
